import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import ItemTypes from './ItemTypes';
import DraggableBox from './DraggableBox';
import Box from './Box';
import update from 'immutability-helper';
import { IconTrash } from '../Icons';
import { getZIndexPlusOne, updateQueryParams } from '../../Utils/VisualizerUtils';

import { StyledContainer, StyledRemoveWrapper } from './WallVisualizerGalleryStyles';

var _ref = React.createElement(IconTrash, null);

var DragContainer = function DragContainer(props) {
  var moveBox = useCallback(function (variantId, left, top, zIndex) {
    var boxIndex = props.selectedProducts.findIndex(function (prod) {
      return prod.variantId === variantId;
    });
    var updatedBoxes = update(props.selectedProducts, _defineProperty({}, boxIndex, {
      $merge: { left: left, top: top, zIndex: zIndex }
    }));
    updateQueryParams({
      queryParams: window.location.search,
      products: updatedBoxes
    });
  }, [props.selectedProducts]);

  var _useDrop = useDrop({
    accept: ItemTypes.BOX,
    drop: function drop(item, monitor) {
      var delta = monitor.getDifferenceFromInitialOffset();
      var left = Math.round(item.left + delta.x);
      var top = Math.round(item.top + delta.y);
      var zIndex = getZIndexPlusOne(props.selectedProducts);
      moveBox(item.variantId, left, top, zIndex);
      return undefined;
    },

    collect: function collect(monitor) {
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      canDrop = _useDrop2$.canDrop,
      isOver = _useDrop2$.isOver,
      drop = _useDrop2[1];

  var removeImageOnDrop = canDrop && props.state.isDragging && !isOver;

  var handleDrag = function handleDrag(dragging) {
    if (dragging && !props.state.isDragging) {
      props.dispatch({ type: 'BOX_DRAG_START' });
    } else if (!dragging && props.state.isDragging) {
      props.dispatch({ type: 'BOX_DRAG_END' });
    }
  };

  return React.createElement(
    StyledContainer,
    {
      ref: drop,
      onDrag: function onDrag() {
        return handleDrag(true);
      },
      onDragEnd: function onDragEnd() {
        return handleDrag(false);
      },
      onTouchMove: function onTouchMove() {
        return handleDrag(true);
      },
      onTouchEnd: function onTouchEnd() {
        return handleDrag(false);
      },
      isSmallThumbnail: props.isSmallThumbnail
    },
    React.createElement(
      StyledRemoveWrapper,
      { active: removeImageOnDrop },
      _ref
    ),
    props.selectedProducts.filter(function (box) {
      return box.category !== 'wallpaper' && box.category !== 'string-lights';
    }).map(function (box) {
      return React.createElement(
        DraggableBox,
        { key: box.variantId, box: box, dispatch: props.dispatch },
        React.createElement(Box, { img: box.img, alt: box.alt })
      );
    })
  );
};

DragContainer.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isSmallThumbnail: PropTypes.bool.isRequired,
  windowWidth: PropTypes.number.isRequired
};

export default DragContainer;